module.exports = __webpack_public_path__ + "static/media/firstam_janet_brehm.06e3b8f3.jpg";